import FormBuilder from "@/components/common/forms/FormBuilder";
import ITable from "@/components/common/table/ITable";

export default function registerCommon(app) {
  app.component('FormBuilder', FormBuilder);
  app.component('ITable', ITable);
}
